/**
 * Nommage des boitiers, en un seul endroit.
 *
 * Un boitier peut suivre plusieurs bains : on nomme le BOITIER, jamais le
 * bain. Entre parentheses vient son NOM RESEAU, remonte par le firmware dans
 * ses diagnostics. Il sert a retrouver le boitier sur le reseau.
 *
 *   Boîtier #15 - Banc MPB-IO V3 (testMPB3)
 *
 * Surtout PAS l'identifiant MQTT (rincage2, niveau1...) : il porte encore
 * un nom de famille de capteur, alors qu'un boitier peut tout mesurer.
 *
 * Le nom d'usage ne doit pas contenir de parentheses : elles sont reservees
 * au nom reseau.
 */

interface IdentiteBoitier {
  boitier_id?: number | null;
  name?: string | null;
  /** Nom reseau remonte par le boitier (diagnostics). */
  hostname?: string | null;
}

/**
 * Libelle complet : « Boîtier #15 - Banc MPB-IO V3 (testMPB3) ».
 * Chaque partie manquante est simplement omise, sans laisser de tiret ni
 * de parenthese orpheline. Tant que le boitier n'a pas publie de
 * diagnostics, on n'affiche aucune parenthese plutot qu'un vide.
 */
export const nomAffichageBoitier = ({
  boitier_id,
  name,
  hostname,
}: IdentiteBoitier): string => {
  const reseau = (hostname || '').trim();
  const tete = boitier_id != null ? `Boîtier #${boitier_id}` : '';
  const base = [tete, name || ''].filter(Boolean).join(' - ') || 'Boîtier';
  return reseau ? `${base} (${reseau})` : base;
};

export default nomAffichageBoitier;
